export enum NotificationType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning'
}
